import { Option } from 'types/Option';
import { TableFilterEntity } from 'types/TableFilter';

import type { AssetCategoryDTO } from './assetCategories.types';
import { AssetCategory } from './assetCategories.types';

const sortCategoriesByName = <T>(categories: T[], getName: (category: T) => string): T[] =>
  [...categories].sort((a, b) => getName(a).localeCompare(getName(b)));

export const parseAllAssetCategoriesForSelect = (raw: AssetCategoryDTO[]): Option[] =>
  sortCategoriesByName(
    raw.map(({ name, name_translation_key, id }) => ({
      key: id,
      label: [name_translation_key, name],
    })),
    category => (category.label[1] as string) || '',
  );

export const parseAllAssetCategoriesForFilters = (raw: AssetCategoryDTO[]): TableFilterEntity[] =>
  sortCategoriesByName(
    raw.map(({ name, name_translation_key, id }) => ({
      id,
      name: [name_translation_key, name],
    })),
    category => (category.name[1] as string) || '',
  );

export const parseAllAssetCategoriesForFE = (raw: AssetCategoryDTO[]): AssetCategory[] =>
  sortCategoriesByName(
    raw.map(({ name, name_translation_key, id }) => ({
      name,
      id,
      nameTranslationKey: name_translation_key,
    })),
    category => category.name,
  );
